import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
	LanguageContext,
	LanguageContextProps,
} from '@/contexts/LanguageContext'
import { useIntl } from 'react-intl'
import { Button } from '@/components/Button'
import ConfirmModal from '@/components/modals/ConfirmModal'
import { navigationLinking } from '@/services/navigation'
import useUser from '@/hooks/useUser'
import useLoanSearch from '@/pages/protected/pipeline/hooks/useLoanSearch'

const localeApplyRouteMap = {
	en: `/${navigationLinking.Apply}`,
	es: `/${navigationLinking.ApplySpanish}`,
}

export default function NewLoanApplicationButton() {
	const navigate = useNavigate()
	const { locale } = useContext<LanguageContextProps>(LanguageContext)
	const { formatMessage } = useIntl()
	const { user, isBorrower } = useUser()

	const [isActiveLoanAlertModalOpen, setIsActiveLoanAlertModalOpen] =
		useState(false)

	const { data: loans } = useLoanSearch({
		userId: user?.id,
		enabled: isBorrower,
	})

	const activeLoanCount = loans.filter((loan) => loan.isActive).length

	const navigateToLoanApplication = () => {
		navigate(localeApplyRouteMap[locale] ?? localeApplyRouteMap.en)
	}

	const handleNewLoanClick = () => {
		if (activeLoanCount > 0 && isBorrower) {
			setIsActiveLoanAlertModalOpen(true)
			return
		}
		navigateToLoanApplication()
	}

	const handleCloseActiveLoanAlertModal = () => {
		setIsActiveLoanAlertModalOpen(false)
	}

	const handleConfirmActiveLoanAlertModal = () => {
		setIsActiveLoanAlertModalOpen(false)
		navigateToLoanApplication()
	}

	return (
		<>
			<Button
				key="new-loan-application-button"
				text={formatMessage({ id: 'pipeline.new_application' })}
				onClick={handleNewLoanClick}
			/>
			<ConfirmModal
				title={formatMessage({
					id: 'pipeline.new_application_modal.title',
				})}
				open={isActiveLoanAlertModalOpen}
				onClose={handleCloseActiveLoanAlertModal}
				onConfirm={handleConfirmActiveLoanAlertModal}
				button={{
					title: formatMessage({
						id: 'pipeline.new_application_modal.confirm',
					}),
				}}
			>
				<p className="text-center">
					{formatMessage(
						{
							id: 'pipeline.new_application_modal.body',
						},
						{
							count: activeLoanCount,
						}
					)}
				</p>
			</ConfirmModal>
		</>
	)
}
